import React, { forwardRef } from 'react'
import { SelectProps } from './type'
import Loading from 'src/components/Loading'
import clsx from 'clsx'

export const Select = forwardRef<HTMLSelectElement, React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> & SelectProps>(({ unselectedLabel, loading, label, error, errorText, options = [], ...props }, ref) => {
    return (
        <div className='flex flex-col items-stretch flex-1 gap-2'>
            <span className={clsx(' text-sm', error ? 'text-red' : 'text-gray-500')}>{label} {!!error && <span className='text-red text-sm'>({errorText})</span>}</span>

            {loading
                ?
                <div className=' py-2  flex flex-row justify-center text-xs md:text-sm text-gray-900 bg-transparent rounded-lg border-[1px] border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-main peer'>
                    <Loading />
                </div>

                : <select ref={ref} {...props} className={clsx(' block px-2.5 pb-2.5 pt-4  text-xs md:text-sm text-gray-900 bg-transparent rounded-lg border-[1px] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-main peer' , error ? 'border-red' : 'border-gray-300' )}>
                    {unselectedLabel && <option value={''}>{unselectedLabel}</option>}
                    {options.map(item => <option value={item.value}> {item.label}</option>)}
                </select>}

                
        </div>
    )
})
